export default function percentChange(original: number, current: number): number {
  if (original > current) return -1 * Math.round(((original - current) / original) * 100);
  return Math.round(((current - original) / original) * 100);
}
